import React from "react";
import YesNoColumn from "./YesNoColumn";

const ServiceVisibilityColumn = ({active}) => <YesNoColumn active={active} activeLabel='Widoczna w aplikacji' inactiveLabel='Niewidoczna w aplikacji'/>

export default ServiceVisibilityColumn;
